import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-parker-info-dialog',
    templateUrl: './parker-info-dialog.component.html',
    styleUrls: ['./parker-info-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ParkerInfoDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
